var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('v-icon',{on:{"mousedown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"]))return null;if('button' in $event && $event.button !== 0)return null;$event.stopPropagation();return _vm.onClickLink.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.icon))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }